import { render, staticRenderFns } from "./selectTopic.vue?vue&type=template&id=264326e9&"
import script from "./selectTopic.vue?vue&type=script&lang=js&"
export * from "./selectTopic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports